module.exports = __webpack_public_path__ + "img/oct_20.7a123327.png";